<script>
    import moment from 'moment'
    export default {
        name: 'AimsOperationInfo',
        props: {
            operation: {
                type: Object,
                default () {
                    return {}
                }
            }
        },
        data () {
            return {
            }
        },
        computed: {},
        created: function () {},
        mounted: function () {},
        beforeDestroy () {},
        watch: {
        },
        methods: {
        },
        filters: {
            dateFilter (value, pattern) {
                if (!value) {
                    value = ''
                }
                if (!pattern) {
                    pattern = 'YYYY-MM-DD'
                }
                return moment(value).format(pattern)
            }
        }
    }
</script>

<template>
    <div>
        <div class="text-right dia-operation-info">
            <p class="pr20 mb10">申请时间：{{operation.applyTime | dateFilter('YYYY年MM月DD日 HH:mm:ss')}}</p>
        </div>
        <table class="table table-condensed border-table">
            <tbody>
            <tr class="odd">
                <td width="3%">床号</td>
                <td width="6%">姓名</td>
                <td width="3%">性别</td>
                <td width="3%">年龄</td>
                <td width="6%">申请日期</td>
                <td width="6%">安排日期</td>
                <td width="3%">手术室</td>
                <td width="14%">诊断</td>
                <td width="14%">手术名称</td>
                <td width="6%">主刀医师</td>
                <td width="6%">第一助手</td>
                <td width="6%">第二助手</td>
                <td width="6%">洗手护士</td>
                <td width="6%">巡回护士</td>
                <td width="6%">麻醉方式</td>
                <td width="6%">麻醉医师</td>
            </tr>
            <tr class="even">
                <td>{{operation.bedid}}</td>
                <td>{{operation.patName}}</td>
                <td>{{!!operation.sex && operation.sex % 2 === 0 ? '女' : '男'}}</td>
                <td>{{operation.age}}</td>
                <td>{{operation.startTime | dateFilter('MM.DD HH:mm')}}</td>
                <td><span v-if="operation.arranged == 1">{{operation.arrangedStartTime | dateFilter('MM.DD HH:mm')}}</span></td>
                <td>{{operation.roomName}}</td>
                <td>{{operation.diagnoseNames}}</td>
                <td>{{operation.operatingNames}}</td>
                <td>{{operation.operatorName}}</td>
                <td>{{operation.assistantFirstName}}</td>
                <td>{{operation.assistantSecondName}}</td>
                <td>{{operation.washNurseName}}</td>
                <td>{{operation.tourNurseName}}</td>
                <td>{{operation.anesthesiaType}}<span v-if="operation.anesthesiaAdditional">({{operation.anesthesiaAdditional}})</span></td>
                <td>{{operation.anesthesiaDocName}}</td>
            </tr>
            <tr class="odd">
                <td colspan="3">手术间要求</td>
                <td colspan="3">设备要求</td>
                <td colspan="10">内固定材料或手术器械要求及其它特殊准备</td>
            </tr>
            <tr class="even">
                <td colspan="3">{{operation.roomDemand || '无'}}</td>
                <td colspan="3">{{operation.device || '无'}}</td>
                <td colspan="10">{{operation.specialPrepare || '无'}}</td>
            </tr>
            </tbody>
        </table>
        <div class="text-right dia-operation-info">
            <span class="pr40">申请医生：{{operation.applyDocName}}</span>
            <span class="pr40">主任审批：{{operation.approveDocName}}</span>
            <span class="pr40">手术室审批：{{operation.arrangerDocName}}</span>
        </div>
    </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .text-right {
        text-align: right;
    }
    .pr20 {
        padding-right: 20px;
    }
    .pr40 {
        padding-right: 20px;
    }
    .mb10 {
        margin-bottom: 10px;
    }
    .table {
        width: 100%;
        max-width: 100%;
        border-spacing: 0;
        border-collapse: collapse;
        font-size: 12px;
        line-height: 22px;
        font-weight: 200;
        margin-bottom: 20px;
    }
    table.border-table {
        border: 1px solid #e2e2e4;
    }
    table.border-table td,
    table.border-table th {
        border-bottom: 1px solid #e2e2e4;
        border-left: 1px solid #e2e2e4;
    }
    table.border-table td:first-child,
    table.border-table th:first-child {
        border-left: 0px solid #e2e2e4;
    }
    .table>tbody>tr>td,
    .table>tbody>tr>th,
    .table>tfoot>tr>td,
    .table>tfoot>tr>th,
    .table>thead>tr>td,
    .table>thead>tr>th {
        padding: 5px;
        line-height: 1.42857143;
        vertical-align: top;
        border-top: 1px solid #ddd;
    }
    .table-condensed>tbody>tr>td,
    .table-condensed>tbody>tr>th,
    .table-condensed>tfoot>tr>td,
    .table-condensed>tfoot>tr>th,
    .table-condensed>thead>tr>td,
    .table-condensed>thead>tr>th {
        padding: 5px;
    }
    .table .odd {
        background: #EFEFF0;
    }
    .table .even {
        background: #ffffff;
    }
    .dia-operation-info {
        color: #8e8e93;
        font-size: 13px;
    }
</style>
